import { render, staticRenderFns } from "./myTravelDetails.vue?vue&type=template&id=187e2fc3&scoped=true&"
import script from "./myTravelDetails.vue?vue&type=script&lang=js&"
export * from "./myTravelDetails.vue?vue&type=script&lang=js&"
import style0 from "./myTravelDetails.vue?vue&type=style&index=0&id=187e2fc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187e2fc3",
  null
  
)

export default component.exports